import { createAction, handleAction } from 'redux-actions'

export const setCategory = createAction('CATEGORY/SET')

export const activeCategory = handleAction(
  setCategory,
  (state, { payload }) => payload,
  'cat-0'
)
